import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AuthenticationActions, NotificationActions } from "../actions";
import { catchError, map, mergeMap, tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "src/app/services/authentication.service";
import { of } from "rxjs";
import { Router } from "@angular/router";
import { create } from "canvas-confetti";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class AuthenticationEffects {
  login$ = createEffect(() =>
    this.actions.pipe(
      ofType(AuthenticationActions.login),
      mergeMap((action) =>
        this.authenticationService.login(action.email, action.password).pipe(
          map((r) => AuthenticationActions.loggedIn({ userInfo: r })),
          catchError((error) => of(AuthenticationActions.loginFailed(error))),
        ),
      ),
    ),
  );

  triggerLogout$ = createEffect(() =>
    this.actions.pipe(
      ofType(AuthenticationActions.logout),
      map((_) => AuthenticationActions.loggedOut()),
    ),
  );

  navigateToLoginPageOnLogout$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(AuthenticationActions.loggedOut),
        tap((_) => this.router.navigate(["/login"])),
      ),
    { dispatch: false },
  );

  navigateHomeAfterLogin$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(AuthenticationActions.loggedIn),
        tap((_) => this.router.navigate(["/"])),
      ),
    { dispatch: false },
  );

  forgotPassword$ = createEffect(() =>
    this.actions.pipe(
      ofType(AuthenticationActions.forgotPassword),
      mergeMap((action) =>
        this.authenticationService.forgotPassword(action.email).pipe(
          map(
            (_) => AuthenticationActions.forgotPasswordLinkSent(),
            catchError((error) =>
              of(AuthenticationActions.forgotPasswordLinkSendingFailed(error)),
            ),
          ),
        ),
      ),
    ),
  );

  navigateToResetPasswordHintPage$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(AuthenticationActions.forgotPasswordLinkSent),
        tap((_) => this.router.navigate(["/reset-password-hint"])),
      ),
    { dispatch: false },
  );

  triggerFailureNotification$ = createEffect(() =>
    this.actions.pipe(
      ofType(AuthenticationActions.forgotPasswordLinkSendingFailed),
      map((_) =>
        NotificationActions.notify({
          notification: {
            durationMs: 5000,
            notificationType: "error",
            notification: this.translate.instant(
              "settings.forgot-password.failure",
            ),
          },
        }),
      ),
    ),
  );

  constructor(
    private readonly actions: Actions,
    private readonly authenticationService: AuthenticationService,
    private readonly router: Router,
    private readonly translate: TranslateService,
  ) {}
}
